<template>
  <b-col md="12" class="mt-5">
    <div class="avatar-box d-flex">
      <div class="avatar my-auto">
        <b-img src="/iconss/traduttori.png"></b-img>
      </div>

      <div class="black-box">
        <AppLogin v-if="userType == 'translator'"></AppLogin>
        <template v-else>
          <h4 class="text-center trad_area">Area Traduttori</h4>
          <p class="text-center">Conosci bene una lingua? Offri la tua disponibilità per correggere le traduzioni automatiche richieste.</p>
          <b-button pill size="sm" variant="outline-danger" to="/users/register/translator" class="m-2"
            >Registrati</b-button
          >
          <b-button pill size="sm" variant="primary" to="/login/translator" class="m-2">Accedi</b-button>
          <div class="text-right mt-2">
            <router-link to="/translators/help" class="small">Istruzioni Traduttori</router-link>
          </div>
        </template>
      </div>
    </div>
  </b-col>
</template>
<script>
import AppLogin from "@/components/CardLogin";

export default {
  name: "HomeTra",
  components: { AppLogin },
  props: ["userType"],
  data() {
    return {};
  },
};
</script>

<style scoped>
.trad_area {
  color: #f49538 !important;
  font-weight: bold;
}
</style>
